import { get, isEmpty } from 'lodash';
import {
  PRINTING_REQUESTS_STATUSES_ID,
  PRINT_ASSIGNED_TO_ID,
  REQUEST,
  REQUEST_STATUS
} from '../../../constants';

const getShipment = row => {
  const printingRequest = get(row, 'customer_request.printing_request');
  if (printingRequest) {
    const bundledShipment = printingRequest.bundled_shipment || get(row, 'bundled_shipment', null);
    return {
      kind: 'print',
      location: printingRequest.location || null,
      shipping_method: printingRequest.shipping_method || null,
      ship_date: printingRequest.ship_date,
      expected_arrival_date: printingRequest.expected_arrival_date,
      assigned_to: printingRequest.assigned_to,
      tracking_number: printingRequest.tracking_number,
      courier: printingRequest.courier || null,
      completed:
        printingRequest.printing_request_status_id === PRINTING_REQUESTS_STATUSES_ID.completed,
      shipping_label_printed: row.shipping_label_printed,
      patient_label_printed: row.patient_label_printed,
      location_id: printingRequest.location_id,
      bundled_shipment: bundledShipment,
      custom_shipping_fee:
        printingRequest.custom_shipping_fee ?? get(bundledShipment, 'custom_shipping_fee', null)
    };
  }

  const retainer = get(row, ['workflow_data', REQUEST.RETAINER]);
  if (isEmpty(retainer) || !retainer.shipping_method) {
    return null;
  }

  return {
    kind: 'retainer',
    location: get(row, 'rx_form.shipping_location', null),
    shipping_method: retainer.shipping_method,
    ship_date: retainer.expected_ship_date,
    expected_arrival_date: retainer.expected_arrival_date,
    assigned_to: PRINT_ASSIGNED_TO_ID.orthoselect,
    tracking_number: get(row, 'rx_form.tracking_number', null),
    courier: get(row, 'rx_form.courier', null),
    completed: retainer.status === REQUEST_STATUS.COMPLETED,
    shipping_label_printed: row.shipping_label_printed,
    patient_label_printed: row.patient_label_printed,
    location_id: get(row, 'rx_form.shipping_location_id', null),
    bundled_shipment: get(row, 'bundled_shipment', null),
    custom_shipping_fee: get(row, 'bundled_shipment.custom_shipping_fee', null)
  };
};

export default getShipment;
